import calc from './calculation-distance'
import types from './types'

const distStep = 1

const Point = types.Point

function resample(shape) {

  function getPoint(index) {
    return new Point(shape[index][0], shape[index][1]);
  }
  function isSame(arr_1, arr_2) {
    let point_1 = { lat: arr_1[0], lng: arr_1[1] }
    let point_2 = { lat: arr_2[0], lng: arr_2[1] }
    return point_1.lat === point_2.lat && point_1.lng === point_2.lng
  }

  const length = shape.length;

  let start = getPoint(0);
  let pre = start;
  let current = null;
  let firstPoint = null

  const res = [[start.lat, start.lng, 0]]
  let totalDistance = 0

  let nextDist = distStep

  for(let i=1; i < length; i++){
    current = getPoint(i)
    totalDistance += calc(pre.lat, pre.lng, current.lat, current.lng)
    if (totalDistance >= nextDist) {
      if (firstPoint && !isSame(firstPoint, res[res.length - 1])) {
        res.push(firstPoint)
      } else {
        res.push([current.lat, current.lng, parseFloat(totalDistance.toFixed(2))])
      }
      nextDist += distStep
    } else {
      firstPoint = [current.lat, current.lng, parseFloat(totalDistance.toFixed(2))]
    }
    pre = current
  }
  res.push([current.lat, current.lng, parseFloat(totalDistance.toFixed(2))])
  return res
}

export default resample
